<template>
	<form class="admin-modify" @submit.prevent="saveAdmin">
		<managing-section>
			<managing-box title="이름">
				<input
					type="text"
					placeholder="이름을 입력하세요"
					ref="nickName"
					v-model="nickName"
				/>
			</managing-box>
			<managing-box v-if="isModifyMode" title="휴대폰">
				<input-text
					class="admin-modify__user-tel"
					placeholder="휴대폰 번호를 입력하세요(숫자로만 입력해주세요)"
					ref="userTel"
					mode="number"
					:input-width="100"
					input-width-unit="%"
					@input="userTel = $event"
					:prop-value="userTel"
				/>
			</managing-box>
			<managing-box title="이메일">
				<input
					type="email"
					ref="eMail"
					v-model="eMail"
					placeholder="이메일을 입력하세요"
				/>
			</managing-box>
			<managing-box title="패스워드">
				<form
					class="admin-modify__password"
					autocomplete="off"
					@submit.prevent
				>
					<input
						type="password"
						:placeholder="
							isModifyMode
								? '변경할 패스워드를 입력하세요'
								: '패스워드를 입력하세요'
						"
						ref="passWord"
						v-model="passWord"
					/>
				</form>
			</managing-box>
			<managing-box v-if="!isModifyMode" title="패스워드 확인">
				<form
					class="admin-modify__password"
					autocomplete="off"
					@submit.prevent
				>
					<input
						type="password"
						placeholder="패스워드를 한번더 입력하세요"
						ref="passWordCheck"
						v-model="passWordCheck"
					/>
				</form>
			</managing-box>
			<template v-else-if="isSupperAdmin">
				<managing-box title="부서">
					<select class="select" v-model="department">
						<option
							v-for="item in getListAddNull(
								'department',
								null,
								'- 선택하세요 -'
							)"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
				</managing-box>
				<managing-box title="직급">
					<select class="select" v-model="position">
						<option
							v-for="item in getListAddNull(
								'position',
								null,
								'- 선택하세요 -'
							)"
							:key="item.id"
							:value="item.id"
						>
							{{ item.name }}
						</option>
					</select>
				</managing-box>
			</template>
			<managing-box v-if="isSupperAdmin" title="관리자 등급">
				<select class="select" v-model="adminLevel">
					<option
						v-for="item in getListAddNull(
							'adminLevel',
							null,
							'- 선택하세요 -'
						)"
						:key="item.id"
						:value="item.id"
					>
						{{ item.name }}
					</option>
				</select>
			</managing-box>
			<managing-box title="프로필사진">
				<img-selector
					:limit-byte="1000000"
					@change="profileChange"
					:src="profileImgUrl"
				/>
			</managing-box>
			<managing-box title="입사일">
				<DateBox v-if="isSupperAdmin" v-model="joinDate" type="date" />
				<input type="text" readonly v-else v-model="joinDate" />
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button type="submit" class="btn-main blue" v-text="'저장'" />
			<button class="btn-main" type="button" @click="closeModal">
				닫기
			</button>
		</div>
	</form>
</template>

<script>
	import moment from 'moment';
	import { getS3Url, uploadS3, checkEmail } from '@/util.js';
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import InputText from '@/components/InputText.vue';
	import ImgSelector from '@/components/ImgSelector.vue';
	import DateBox from '@/components/DateBox';

	export default {
		name: 'AdminModify',
		components: {
			ManagingSection,
			ManagingBox,
			InputText,
			ImgSelector,
			DateBox,
		},
		data() {
			return {
				isModifyMode: true,
				idRegister: '',
				nickName: '',
				userTel: '',
				eMail: '',
				passWord: '',
				passWordCheck: '',
				department: null,
				position: null,
				adminLevel: null,
				profileImgUrl: '',
				joinDate: moment().format('YYYY-MM-DD'),
				profileData: null,
			};
		},
		computed: {
			...mapState({
				imgPath: state => state.env.IMAGE_STORAGE_PATH,
				modalParams: state => state.modal.params,
				currAdminLevel: state => state.login.adminLevel,
			}),
			...mapGetters(['getListAddNull']),
			isSupperAdmin() {
				return this.currAdminLevel === 1;
			},
		},
		mounted() {
			this.setData();
		},
		methods: {
			setData() {
				if (!this.modalParams) {
					this.isModifyMode = false;
					return;
				}
				const data = this.modalParams.obj;
				this.idRegister = data.idRegister;
				this.nickName = data.nickName;
				this.userTel = data.userTel;
				this.eMail = data.eMail;
				if (data.fileDir && data.fileSaveName) {
					this.profileImgUrl = `${this.imgPath}${data.fileDir}/${data.fileSaveName}`;
				}
				this.joinDate = data.joinDate;
				this.department = data.department;
				this.position = data.position;
				this.adminLevel = data.adminLevel;
			},
			profileChange(obj) {
				if (!obj) this.profileImgUrl = '';
				this.profileData = obj;
			},
			validate() {
				if (!this.nickName) {
					this.$refs.nickName.focus();
					alert('이름을 입력하세요.');
					return false;
				}
				if (!this.eMail) {
					this.$refs.eMail.focus();
					alert('이메일을 입력하세요.');
					return false;
				}
				if (!checkEmail(this.eMail)) {
					this.$refs.eMail.focus();
					alert('이메일주소 형식으로만 입력이 가능합니다.');
					return false;
				}
				if (this.passWord && this.passWord.length < 6) {
					this.$refs.passWord.focus();
					alert('비밀번호를 6글자이상으로 입력해 주세요.');
					return false;
				}
				if (this.isModifyMode) {
					if (!this.userTel) {
						this.$refs.userTel.$refs.InputText.focus();
						alert('휴대폰 번호를 입력하세요.');
						return false;
					}
				} else {
					if (!this.passWord) {
						this.$refs.passWord.focus();
						alert('비밀번호를 입력하세요');
						return false;
					}
					if (!this.passWordCheck) {
						this.$refs.passWordCheck.focus();
						alert('비밀번호 확인을 입력하세요');
						return false;
					}
					if (this.passWord !== this.passWordCheck) {
						this.$refs.passWordCheck.focus();
						alert('비밀번호는 동일하게 입력해야 합니다');
						return false;
					}
					if (this.adminLevel === null) {
						alert('관리자 등급을 선택하세요');
						return false;
					}
					if (!confirm('정말 등록 하시겠습니까?')) {
						return false;
					}
				}
				return true;
			},
			async updateImg() {
				try {
					const { data } = await getS3Url(
						this.profileData.extension,
						'home/glowmee/upload'
					);
					await uploadS3(data, this.profileData.fileObj);
					return data;
				} catch (err) {
					console.error(err);
					alert(
						'프로필이미지를 업로드하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async saveAdmin() {
				try {
					if (!this.validate()) return;
					const url = '/admin/adminAccount';
					const adminAccount = {
						nickName: this.nickName,
						userTel: this.userTel,
						eMail: this.eMail,
						passWord: this.passWord,
						department: this.department,
						position: this.position,
						adminLevel: this.adminLevel,
						joinDate: this.joinDate,
					};
					if (this.profileData) {
						const s3Obj = await this.updateImg();
						const fileObj = this.profileData.fileObj;
						const keyArr = s3Obj.fields.key.split('/');
						adminAccount.fileOrgName = fileObj.name;
						adminAccount.fileSaveName = keyArr.pop();
						adminAccount.fileDir = `/${keyArr.join('/')}`;
						adminAccount.fileSize = fileObj.size;
						adminAccount.fileType = s3Obj.fields['Content-Type'];
					}
					if (this.isModifyMode) {
						adminAccount.idRegister = this.idRegister;
						await this.$axiosSupport.put(
							`${url}/${this.idRegister}`,
							{ adminAccount }
						);
					} else {
						adminAccount.adminLevel = this.adminLevel;
						await this.$axiosSupport.post(url, { adminAccount });
					}
					window.location.reload();
				} catch (err) {
					console.error(err);
					alert('저장하는데 실패했습니다. 개발팀에 문의하세요.');
				}
			},
			closeModal() {
				this.$store.commit('modal/toggleModal', {});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.admin-modify__password {
		display: block;
		width: 100%;
	}

	.admin-modify__user-tel {
		width: 100%;
	}
</style>
